import getAppState from 'app-state';
import { CartOrderItem, CartSkuOption } from 'cart-core';
import { addToCart } from 'cart-ui';
import { Modal } from 'forms/src';
import { GtagCartUpdateMethod } from 'google-analytics'; // ensure window.gtag exists.
import LoadingSpinner from 'loading-spinner/LoadingSpinner';
import t from 'rcm-i18n';
import React, { Component } from 'react';
import AddToCartQuantityAndSkuForm from './AddToCartQuantityAndSkuForm';
import AddToCartSuccessScreen from './AddToCartSuccessScreen';
const showPriceExcludesVatTaxMessage = getAppState(
  'cartConfig.showPriceExcludesVatTaxMessage',
  false
) as boolean;

interface Props {
  onMount?: (open: () => void) => void;
  productId: string;
  onContinueShopping?: () => void;
  skuOptions: CartSkuOption[];
  isOpen?: boolean;
  cart_update_method: GtagCartUpdateMethod;
  productIndex: string;
}

interface State {
  isOpen: boolean;
  addedToCart: boolean;
  networkErrorOccurred: boolean;
  loading: boolean;
}

export default class AddToCartPopupContainer extends Component<Props, State> {
  public static defaultProps: Partial<Props> = {
    isOpen: false,
    onContinueShopping: () => {},
    onMount: () => {},
  };

  public state: State = {
    addedToCart: false,
    isOpen: false,
    loading: false,
    networkErrorOccurred: false,
  };

  protected handleAddToCart = async (items: CartOrderItem[]) => {
    this.setState({
      addedToCart: false,
      loading: true,
      networkErrorOccurred: false,
    });
    try {
      await addToCart(items, {
        cart_update_method: this.props.cart_update_method,
      });
      this.setState({
        addedToCart: true,
        loading: false,
      });
    } catch (error) {
      console.error(error);
      this.setState({ networkErrorOccurred: true, loading: false });
    }
  };

  public componentDidMount() {
    if (!this.props.onMount) {
      return;
    }
    this.props.onMount(() => this.setState({ isOpen: true }));
  }

  protected handleContinueShopping = () => {
    if (this.props.onContinueShopping) {
      this.props.onContinueShopping();
    }
    this.setState({ isOpen: false });
  };

  protected handleFadeOut = () => {
    this.setState({
      addedToCart: false,
      isOpen: false,
      loading: false,
      networkErrorOccurred: false,
    });
  };

  public render() {
    if (this.state.loading) {
      return <LoadingSpinner />;
    }

    return (
      <Modal
        show={this.state.isOpen || this.props.isOpen}
        className='add-to-cart-pop-up'
        onFadeOut={this.handleFadeOut}
      >
        {this.state.networkErrorOccurred && (
          <div className='alert alert-warning' role='alert'>
            {t(
              'An error occurred. Please check your internet connection and try again.'
            )}
          </div>
        )}
        {this.state.addedToCart && (
          <AddToCartSuccessScreen
            onContinueShopping={this.handleContinueShopping}
          />
        )}
        {!this.state.addedToCart && (
          <AddToCartQuantityAndSkuForm
            skuOptions={this.props.skuOptions}
            onContinueShopping={this.handleContinueShopping}
            onAddToCart={this.handleAddToCart}
            showPriceExcludesVatTaxMessage={showPriceExcludesVatTaxMessage}
            productIndex={this.props.productIndex}
          />
        )}
      </Modal>
    );
  }
}
